import { CommonService } from 'wire-frame';
import { inject } from '@angular/core';
import { CanActivateChildFn } from '@angular/router';
import {
  getAdminNavConfig,
  isPathAllowed,
  menusForWireFrame,
} from './config/admin-nav.config';
import { ToasterService } from './service/common/toaster.service';

export const authGuard: CanActivateChildFn = (childRoute, state) => {
  const common = inject(CommonService);
  const toaster = inject(ToasterService);
  const loggedInUser = JSON.parse(sessionStorage.getItem('loggedInUser') || '{}');
  const navConfig = getAdminNavConfig(loggedInUser?.type);

  if (navConfig && isPathAllowed(navConfig.allowedPaths, state.url)) {
    common.setMenu([]);
    common.setMenu(menusForWireFrame(navConfig.menus));
    return true;
  }

  common.setMenu([]);
  toaster.warn('You are not permitted to access this page.', 'Access denied');
  common.redirect('/admin/dashboard');
  return false;
};
